import React from 'react';
import { Spinner, SpinnerSize } from 'ui-toolkit';

interface IWorkingWrapperProps {
  working: boolean;
  children: React.ReactNode;
}

export default class WorkingWrapper extends React.Component<IWorkingWrapperProps> {
  public render() {
    const { children, working } = this.props;
    return working ? (
      <div style={{ alignItems: 'center', display: 'grid', justifyItems: 'center', gap: '16px' }}>
        <Spinner size={SpinnerSize.regular} />
        <h3>Working...</h3>
      </div>
    ) : (
      children
    );
  }
}
